// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_T_1","cls2":"PaywallPage-cls2_4R4 PaywallPage-cls1_T_1"};